import mapInboxRuleToInboxRuleInformation from './utils/mapInboxRuleToInboxRuleInformation';
export default {
    enableDisableInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_EnableDisableInboxRule',
            customData: function (inboxRuleId, shouldBeEnabled, force, alwaysDeleteOutlookRulesBlob) { return [inboxRuleId, shouldBeEnabled, force, alwaysDeleteOutlookRulesBlob]; },
        },
    },
    generateInboxRulesDiagnosticReportDatapoint: {
        datapoint: { name: 'TnS_GenerateInboxRulesDiagnosticReport' },
    },
    getInboxRulesDatapoint: { datapoint: { name: 'TnS_GetInboxRules' } },
    // logs information about each individual rule from the getInboxRules response
    getInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_GetInboxRule',
            customData: function (inboxRule) {
                return mapInboxRuleToInboxRuleInformation(inboxRule);
            },
        },
    },
    editInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_EditInboxRule',
            customData: function (inboxRule) {
                return mapInboxRuleToInboxRuleInformation(inboxRule);
            },
        },
    },
    createNewInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_NewInboxRule',
            customData: function (inboxRule, actionSource, onSuccess, onFailure) {
                var result = mapInboxRuleToInboxRuleInformation(inboxRule);
                result.ActionSource = actionSource;
                return result;
            },
        },
    },
    setInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_SetInboxRule',
            customData: function (inboxRule, force, alwaysDeleteOutlookRulesBlob) {
                var result = mapInboxRuleToInboxRuleInformation(inboxRule);
                result.Force = force;
                result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
                return result;
            },
        },
    },
    numInboxRules: {
        datapoint: {
            name: 'TnS_NumInboxRules',
            customData: function (inboxRuleCollectionLength) { return [inboxRuleCollectionLength]; },
        },
    },
    removeInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_RemoveInboxRule',
            customData: function (inboxRule, force, alwaysDeleteOutlookRulesBlob) {
                var result = mapInboxRuleToInboxRuleInformation(inboxRule);
                result.Force = force;
                result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
                return result;
            },
        },
    },
    setInboxRulesDatapoint: { datapoint: { name: 'TnS_SetInboxRules' } },
    inboxRuleInformationDatapoint: {
        datapoint: {
            name: 'TnS_InboxRuleInformation',
            customData: function (inboxRuleInformation) {
                return inboxRuleInformation;
            },
        },
    },
    addPhraseToClauseDatapoint: {
        datapoint: {
            name: 'TnS_AddPhraseToClause',
            customData: function (clauseId, phraseToAdd, actionSource) { return [phraseToAdd.indexOf(' ') !== -1, actionSource]; },
        },
    },
    inboxRuleActionFailDatapoint: {
        datapoint: {
            name: 'TnS_InboxRuleActionFail',
            customData: function (inboxRuleInformation) {
                return inboxRuleInformation;
            },
        },
    },
};
//# sourceMappingURL=datapoints.js.map